// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const StyledBtnGroupWrapper = styled("div")`
	display: inline-flex;
	margin-left: auto;
`;

// #####################################################
